/* eslint-disable import/prefer-default-export */
// const crmPointV2Prefix = '/api/v2/crm-points';

export const routes = {

  configRecruiter: {
    get_ethnicities: "/api/recruiter/get_configuration_list/",
  },

  AUTH: {
    // FORGOT_PASSWORD: "/api/v1/user/forgot-password/",

    LOGIN: "/api/ua/login/",
    RESET_PASSWORD: "/api/ua/forgot_password/",  // send email to reset password
    CHANGE_PASSWORD: "/api/ua/change_password/", // change password
    OAUTH2_CALLBACK: "/api/ua/oauth2/callback/", // ClassLink OAuth2 callback
    OAUTH3_CALLBACK: "/api/ua/oauth2/clever/", // ClassLink OAuth3 callback

    // REFRESH_TOKEN: "/api/user/generate_access_token",
    // PASSWORD_VERIFY_TOKEN: "/api/v1/user/password-verify-token",
    // RESET_PASSWORD: "/api/v1/user/forgot-password/confirm/",
    // VERIFY_OTP: '/api/user/auth/verify_otp',
    // RESET_OTP: '/api/user/auth/send_otp'
    // LOGOUT: "/api/v1/user/logout-from-all",
  },
  registerChild: {
    registerChild: "/api/student/add_child/",
  },
  STUDENT: {
    GOAL: "/api/v1/goal",
    STUDENT_GOAL: "/api/student/studentgoal/",
    STUDENT_HISTORY: "/api/student/history/",
    STUDENT_SAVE_REFLECTION: "/api/student/student_reflections/",
    STUDENT_INSIGHTS: "/api/student/insights/",

    // Parent
    PARENT_GET_GOAL_BY_STUDENT: "/api/student/studentgoal/",
    PARENT_GET_STUDENT_COURSE: "/api/student/studentgoal/",
    PARENT_HISTORY: "/api/student/history/",
    STUDENT_PDF_REFLECTION: "/api/student/pdf/"
  },
  PORTFOLIO: {
    // CONFIGURELIST: "/api/v1/configure?limit=200",
    GET_INTEREST: "/api/student/interest/",
    SAVE_INTEREST: "/api/student/save_interest/",
    TRANSLATE: "/api/student/translate/",
    GET_ACADEMICS: "/api/student/academics/",
    GET_ACTIVITIES: "/api/student/activities/",
    GET_ATHLETICS: "/api/student/athletics/",
    SAVE_ACTIVITIES: "/api/student/save_activity/",
    SAVE_ACADEMICS: "/api/student/save_academic/",
    SAVE_ATHLETICS: "/api/student/save_athletics/",
    GET_CURRICULUM: "/api/student/curriculum/",
    GET_REFLECTION: "/api/student/student_reflections/",
    GET_CURRICULUM_UPLOAD: "/api/student/curriculum_upload/",
    SAVE_CURRICULUM: "/api/student/save_curriculum/",
    SAVE_CURRICULUM_UPLOAD: "/api/student/save_curriculum_upload/",

    // Parent Role
    PARENT_GET_INTEREST: "/api/student/mybragbook/",
    PARENT_ACADEMY_DETAIL: "/api/student/mybragbook/", // academy, activity, interest
  },
  TRANSLATE: {
    TRANSLATE: "/api/student/translate/",
    TRANSLATE_CURR: "/api/student/translate_curr/",
    PARENT_TRANSLATE_MESSAGE: "/api/v1/message/translatev1/",
    PARENT_TRANSLATE_BRAGBOOK: "/api/student/translate/",
  },
  LADDER: {
    GET_LADDER: "/api/student/get_ladder/",
    SAVE_LADDER: "/api/student/update_ladder/",

    // Parent Role Ladder API
    PARENT_GET_STUDENTS: "/api/student/get_student/",
    PARENT_GET_LADDERS: "/api/student/get_ladder/",
  },
  PROFILE: {
    UPDATE_PROFILE: "/api/student/update-profile/",
    PROFILE_UPLOAD: "/api/student/attachment/",
    // Parent
    PARENT_UPDATE_PROFILE: "/api/student/update-profile/"
  },
  CALENDER: {
    CALENDER: "/api/student/calendar/",
  },
  MESSAGE: {
    GET_UNREAD_MESSAGE_COUNT: "/api/student/notification/",  // POST
    GET_MESSGAE_LIST_PER_USER: "/api/student/received_message/", // POST
    SEND_MESSAGE: "/api/student/sent_message/",  //POST
    READ_COUNT_DATE: "/api/student/message_read/", //POST
    VERIFY_NUDGE: "/api/student/verify_nudge/",
    SEND_OTP: "/api/student/send_otp/",
    RESEND_OTP: "/api/student/resend_otp/",
    VERIFY_OTP: "/api/student/verify_otp/",
    TWILIO_COST_ESTIMATION: "/api/student/twilio_message_cost_estimation/",
    APPROVALS: "/api/student/approvals/",
    STATUS_UPDATE: "/api/student/status_update/",
    GET_COLLEGE_LIST: "/api/student/get_college_list/",
    GET_DISTRICT_LIST: "/api/student/get_district_list/",
    GET_REQUESTER_LIST: "/api/student/get_requester_list/",

    // Parent
    PARENT_GET_UNREAD_MESSAGE_COUNT: "/api/student/notification/",
    PARENT_GET_MESSAGES_PER_USER: "/api/v1/message/get_ack_message/",
  },
  SCHOOL: {
    GET_SCHOOL_LIST: "/api/ua/get_school/",  // GET
  },
  STUDENT_REGISTER: {
    STUDENT_DETAIL_CHECK: "/api/ua/user_details_check/",  // POST
    REGISTER_COUNST: "/api/v1/register/counst", // GET
    CREATE_STUDENT_ACCOUNT: "/api/ua/user_details_update/",  // POST
    COUNTRY_CHECK: `/api/ua/countries/`,
    STATE_CHECK: `/api/ua/states/`,
    PERSONAL_EMAIL_CHECK: `/api/ua/signup_personal/`,
    PERSONAL_OTP_VERIFY: `/api/ua/verify_otp/`,
  },
  GET_DISTRICT: "/api/ua/get_district/",
  recruiterDistrictList: {
    recruiterDistrictList: "/api/recruiter/get_district_list/",
  },
  GET_DISTRICT_BASE_SCHOOL: "/api/ua/get_school/",
  PARENT_REGISTER: "/api/ua/parent_registration/",
  PERSONAL_STUDENT_REGISTER: "/api/ua/collect_personal_info/",


  auth: {
    LOGOUT: "/api/ua/logout/",
  },
  updateProfile: {
    UPDATE_PROFILE: "/api/student/update-profile/",
  },
  msg: {
    GET_MESSAGE_LIST: "/api/v1/discussion/page",
    GET_PARENT_COUNT: "/api/student/parent_notification/",
    GET_TOTAL_MESSAGE_LIST: "/api/student/sender_count/",
  },
  getCannedMsg: {
    GET_CANNED_MSG: "/api/recruiter/message_template/",
  },
  getListOfStudent: {
    GET_LIST: "/api/recruiter/search_user/",
  },
  sendMessage: {
    SEND_MESSAGE: "/api/student/sent_message/",
  },
  sendSftp: {
    SEND_SFTP: "/api/sftp/sftp_process/",
  },
  attachment: {
    ATTACHMENT: "/api/recruiter/message_attachment/",
  },
  deleteMessage: {
    DELETE_REC_MESSAGE: "/api/recruiter/delete_message/",
    DELETE_MESSAGE: "/api/counsellor/deleted_message/",
    DELETE_GROUP_MESSAGE: "/api/counsellor/message_group/",
    DELETE_SCHEDULE_MESSAGE: "/api/counsellor/schedule_message/",
  },
  getGender: {
    GET_GENDER: "/api/v1/configure?list_name=gender",
  },

  //siembra
  getEthnicity: {
    GET_ETHNICITIES: "/api/v1/translate/ethnicity",
  },
  //school_It
  getEthnicity: {
    GET_ETHNICITIES_IT: "/api/v1/configure?list_name=ethnicity",
  },

  //siembra
  getEthnicity: {
    GET_ETHNICITIES: "/api/v1/translate/ethnicity",
  },


  //CCC
  getCCC: {
    GET_CCC: "/api/recruiter/ccc_query_page/",
  },

  //International
  getInternational: {
    GET_INTERNATIONAL: "/api/recruiter/intl_configuration_list/",
  },


  //Siembra
  getAAAI: {
    GET_AAAI: "/api/v1/configure/alladvancedQuery",
  },

  //CCC
  getAAAIS: {
    GET_AAAIS: "/api/recruiter/ccc_query_page/"
  },

  // config: {
  //   getConfig: "/api/v1/configure?limit=200&name=configuration_list",
  // },
  getQueryResult: {
    getQueryResult: "/api/v1/result/query_result",
  },
  getAdvanceParameters: {
    getAdvanceParameters: "/api/recruiter/get_configuration_list/",
  },
  getResultDisplay: {
    getResultDisplay: "/api/v1/result/result_display",
  },

  //custom
  getResultPage: {
    getResultPage: "/api/recruiter/high_school_query/",
  },
  //fav premium student
  getFavoritePage: {
    getFavoritePage: "/api/recruiter/myfavstudent/",
  },
  //college
  getCollegeResultPage: {
    getCollegeResultPage: "/api/recruiter/ccc_query/",
  },

  //international
  getInternationalResultPage: {
    getInternationalResultPage: "/api/recruiter/international_student_query/",
  },


  getSchoolPage: {
    getSchoolQuery: "/api/recruiter/query_manager/",
  },
  deleteQuery: {
    deleteQuery: "/api/v1/result/delete",
  },
  duplicateQueryForSaved: {
    duplicateQueryForSaved: "/api/v1/result/duplicate",
  },
  saveQuery: {
    saveQuery: "/api/v1/result/save",
  },
  saveQueryForCollege: {
    saveQueryForCollege: "/api/recruiter/query_manager/",
  },
  highSchoolName: {
    highSchoolName: "/api/recruiter/get_school/",
  },
  schoolList: {
    schoolList: "/api/recruiter/get_school_list/",
  },
  viewQuery: {
    viewQuery: "/api/recruiter/query_manager/",
  },
  duplicateQuery: {
    duplicateQuery: "/api/v1/query/duplicate",
  },
  deleteForSchoolQuery: {
    deleteForSchoolQuery: "/api/recruiter/query_manager/",
  },
  campaignPage: {
    campaignPage: "/api/v1/campaign/page",
  },
  bannerPage: {
    bannerPage: "/api/v1/banner/page",
  },
  // getCampaignResultTable: {
  //   getCampaignResultTable: "/api/v1/result/page",
  // },
  getCampaignQuery: {
    getCampaignQuery: "/api/v1/query",
  },
  getQuery: {
    getCampaignQuery: "/api/v1/query",
  },
  getCampaignBannerQuery: {
    getCampaignBannerQuery: "/api/v1/banner",
  },
  createCampaign: {
    createCampaign: "/api/v1/campaign/save",
  },
  deleteCampaign: {
    deleteCampaign: "/api/v1/campaign/delete",
  },
  editCampaign: {
    editCampaign: "/api/v1/campaign/",
  },
  deleteForBannerRequirement: {
    deleteForBannerRequirement: "/api/v1/banner/requirements",
  },
  uploadBannerImage: {
    uploadBannerImage: "/api/v1/banner/upload-image",
  },
  createBanner: {
    createBanner: "/api/v1/banner/create",
  },
  getMessageTemplate: {
    getMessageTemplate: "/api/recruiter/message_template/",
    getMessageNudgeTemplate: "/api/counsellor/message_template/",
    getSection: "/api/counsellor/template_sections/",
  },
  deleteMessageTemplate: {
    deleteMessageTemplate: "/api/recruiter/message_template/",
  },
  cannedMessageForTemplate: {
    cannedMessageForTemplate: "/api/recruiter/message_template/",
  },
  cannedMessageTemplateForSuperCounselor: {
    cannedMessageTemplateForSuperCounselor: "/api/recruiter/message_template/",
  },
  save_via_result: {
    save_via_result: "/api/v1/result/save",
  },
  save_via_query: {
    save_via_query: "/api/v1/result/save_via_query",
  },
  //custom-query
  export_result: {
    export_result: "/api/recruiter/export_csv_high_school/",
  },
  //ccc
  export_result_ccc: {
    export_result_ccc: "/api/recruiter/ccc_export_csv/",
  },
  //international
  export_result_international: {
    export_result_international: "/api/recruiter/international_export/",
  },
  //For Student
  login: {
    login: "/api/ua/login",
  },
  getLadder: {
    getLadder: "/api/v1/configure/ladder",
  },
  saveLadder: {
    saveLadder: "/api/v1/configure/ladder",
  },
  getAcademics: {
    getAcademics: "/api/v1/configure/academics",
  },
  getAthletics: {
    getAthletics: "/api/v1/configure/athletics",
  },
  getActivities: {
    getActivities: "/api/v1/configure/activities",
  },
  configureList: {
    configureList: "/api/v1/configure?limit=200",
  },
  saveActivities: {
    saveActivities: "/api/v1/configure/activitysave",
  },
  saveAcademics: {
    saveAcademics: "/api/v1/configure/academicsave",
  },
  saveAthletics: {
    saveAthletics: "/api/v1/configure/athleticssave",
  },
  getInterest: {
    getInterest: "/api/v1/configure/interest",
  },
  saveInterest: {
    saveInterest: "/api/v1/configure/interestsave",
  },
  translate: {
    translate: "/api/student/translate/",
  },
  studentgoal: {
    requirement: "/api/v1/studentgoal/requirement",
    studentgoal: "/api/student/student_status/",
    goal: "/api/counsellor/goal_criteria/",
    goaldata: "/api/counsellor/student_status_counselor/",
    fail_list: "/api/counsellor/fail_list/ ",
    student_progress: "/api/counsellor/student_progress/",
    getGroupPage: "/api/counsellor/manage_group/",
    details: "/api/student/history/",
    myfavStudent: "/api/recruiter/myfavstudent/",
    downloadTrans: "/api/recruiter/download/",
    deleteTrans: "/api/recruiter/myfavstudent/",
    deleteSpecificGroup: "/api/counsellor/manage_group/",
  },
  getSingleMessageForStudent: {
    gettingIdForMessageList: "/api/v1/discussion/pagenew",
    getSingleMessageForStudent: "/api/v1/discussion",
    getUnreadMessageCount: "/api/student/notification/",
    date: "/api/student/message_read/",
  },
  calendar: {
    calender: "/api/student/calendar/",
  },
  profileUpload: {
    profileUpload: "/api/v1/me/attachment",
  },
  query_result_pagination: {
    query_result_pagination: "/api/student/sent_message/",
  },
  getTimezone: {
    getTimezoneList: "/api/counsellor/timezone_list/",
  },
  // Counselor Routes
  counselor: {
    sendScheduleMessage: "/api/counsellor/schedule_message/",
    get_schdule_messages: "/api/counsellor/schedule_message/",
    getMsgListCount: "/api/counsellor/deleted_message/",
    getStudentForCounselor: "/api/counsellor/counsellor_dashboard/",
    addToWatchlist: "/api/counsellor/watchlist/",
    studentgoal_requirement: "/api/counsellor/requirement/",
    studentmigrate_status: "/api/counsellor/migrate_status/",
    studentdataperId: "/api/admin/student_list/",
    goalPublishManage: "/api/counsellor/status_calculation/",
    getStudent: "/api/counsellor/counsellor_dashboard/",
    saveGroup: "/api/counsellor/manage_group/",
    currentStudent: "/api/counsellor/counsellor_dashboard/",
    allStudentPDF: "/api/student/pdf/",
    send_single_invite: "/api/counsellor/send_single_invite/",
    add_existing_student_list: "/api/counsellor/counsellor_dashboard/",
    add_existing_student: "/api/counsellor/add_student/",
    getStudentListForCounselor: "/api/v1/me/students",
    getMsgList1: "/api/v1/message-group/page/",
    getMsgList: "/api/student/sender_count/",
    reply: "/api/v1/discussion",
    getCollegeName: "/api/admin/college_view/",
    getRecruiterName: "/api/recruiter/search_user/",
    getData: "/api/counsellor/download_statistics/",
    getGroupName: "/api/counsellor/search_group/",
    getAddStudentGroup: "/api/counsellor/add_student_into_group/",
    getRemoveStudentGroup: "/api/counsellor/remove_student_from_group/",
    sendGroupMessage: "/api/counsellor/message_group/",
    getDeleteGroupMessage: "/api/counsellor/message_group/",
    getDeleteGroupMessage1: "/api/v1/message-group/page/",
    selectedGroupListStudent: "/api/counsellor/download_student_list/",
    groupListStudent: "/api/counsellor/group_student_list/",
    override: "/api/counsellor/simple_expression_override/",
    cannedMessage: "/api/recruiter/message_template/",
    createCalendarEvent: "/api/student/calendar/",
    deleteCalendarEvent: "/api/student/calendar/",
    getCalendarEvent: "/api/student/calendar/",
    restoreMessage: "/api/counsellor/deleted_message/",
    unoverride: "/api/counsellor/simple_expression_un_override/",
    message_group: "/api/v1/message-group",
    msg_group: "/api/v1/discussion/msg_group",
    status_calculation: "/api/counsellor/status_calculation/",
  },
  superCounselor: {
    getStudentForCounselor: "/api/counsellor/counsellor_dashboard/",
    getStudentStatisticsData: "/api/counsellor/goal_statistics/",
    download_status: "/api/counsellor/download_statistics/",
    getMyGroupList: "/api/counsellor/group_student_list/",
  },
  schoolIT: {
    school_it_student_del: "/api/counsellor/remove_student_from_group/",
    school_it_gr_delete: "/api/counsellor/manage_group/",
    received_message: "/api/student/received_message/",
    goalPublish1: "/api/v1/coursepublish/schoolpublish",
    details: "/api/student/history/",
    getStudent: "/api/admin/user_operation/",
    getSchoolsList: "/api/admin/school_detail_view/",
    studentCount: "/api/admin/student_list/",
    studentModifyData: "/api/admin/user_operation/",
    downloadStudent: "/api/recruiter/search_user/",
    getMaintainGroup: "/api/v1/group",
    getMaintainCreateGroup: "/api/counsellor/manage_group/",
    getMaintainGroupIT: "/api/counsellor/manage_group/",
    getShowMaintain: "/api/counsellor/group_student_list/",
    getStudentStatisticsData: "/api/counsellor/goal_statistics/",
    status_calculation: "/api/counsellor/status_calculation/",
    getStudentForMaintainGroup: "/api/counsellor/counsellor_dashboard/",
    addStudentInGroup: "/api/counsellor/add_student_into_group/",
    getMessageForSchoolIt: "/api/student/sender_count/",
    deleteStudentMessage: "/api/counsellor/deleted_message/",
    getCounselor: "/api/admin/user_operation/",
    getActivities: "/api/admin/taglist/",
    saveStudent: "/api/admin/user_operation/",
    goalPage: "/api/v1/goal/page",
    coursePage: "/api/v1/course/page",
    duplicateGoal: "/api/v1/goal/duplicate",
    goalrequirement: "/api/v1/goal/requirement",
    getSelectedCourse: "/api/v1/course",
    getGoalDetail: "/api/v1/goal",
    deleteGoalDetail: "/api/v1/goal/goal-delete",
    listOfCourse: "/api/v1/coursepublish",
    fieldOperators: "/api/v1/field_operators",
    dataSrcPage: "/api/v1/datasrc/page",
    DataSrc: "/api/v1/datasrc",
    runStatusDataSrc: "/api/v1/datasrc/runstatus",
    uploadStudentData: "/api/v1/datasrc/upload-studentdata ",
    uploadDataHistory: "/api/v1/ds_history/pag",
    deleteHistoryItem: "/api/v1/ds_history/del_upload",
    mapCollegeConfigurelist: "/api/v1/configure/maplist",
    goalFieldTypes: "/api/v1/goal_field_types",
    dataSourceCol: "/api/v1/datasrc_col",
    arithemetic: "/api/v1/arithmetic_operators",
    fieldTypes: "/api/v1/fieldtypes",
    goalFieldForCreateGoal: "/api/v1/goalfield",
    goalFieldForSaveGoal: "/api/v1/goalfieldmap/save",
    goalFieldForRemoveGoal: "/api/v1/goalfieldmap/check",
    uploadFile: "/api/v1/course/upload-file",
    uploadFileAfter: "/api/v1/course/upload-courselist",
    saveMapSchoolCollege: "/api/v1/collegecriteriamap/save",
    saveMapForModalOptions: "/api/v1/collegemapexpression/save",
    mapList: "/api/v1/goalfield/maplist",
    coursePublish: "/api/v1/coursepublish/schoolpublish",
    goalPublish: "/api/v1/goalpublish/schoolpublish",
    calculateGoalPublish: "/api/v1/goalpublish/calculate",
    updateDefaultGoal: "/api/v1/goal/def",
    createGoalMap: "/api/v1/goal/create",
    mapSchoolGoalSave: "/api/v1/goalfieldmap/save",
    courseMap: "/api/v1/course_map",
    uploadFileForCSVImport: "/api/v1/admin/upload-csv",
    duplicateCourse: "/api/v1/course/duplicate",
    listUpdateMapCourse: "/api/v1/course_list/list-update",
    mergeStudent: "/api/admin/merge",
    getDistrictsList: "/api/v1/me/district",
    getDataSwal: "/api/v1/setup/school-setup-process"
  },
  admin: {
    queryShowData: "/api/admin/configuration_list/",
    createSchoolIT: "/api/admin/user_operation/",
    updateSchoolIT: "/api/admin/user_operation/",
    deleteSchoolIT: "/api/admin/user_operation/",
    getSchoolsList: "/api/admin/school_detail_view/",
    getRefClassesList: "/api/student/course_list/",
    getAllSchoolsList: "/api/admin/school_detail_view/",
    getCollegesList: "/api/admin/college_view/",
    getDistrictsList: "/api/admin/district/",
    getReportSFTP: "/api/admin/download_sftp_status_detail/",
    getStudentStatistics: "/api/admin/admin_statistics/",
    getStudentStatisticsExcel: "/api/admin/download_statistics/",
    GET_CANNED_PAGE: "/api/recruiter/message_template/",
    getCannedMessage: "/api/recruiter/message_template/",
    adminPage: "/api/admin/user_operation/",
    cannedMessage: "/api/recruiter/message_template/",
    counselorAdmin: "/api/admin/user_operation/",
    getCounselorsList: "/api/admin/user_operation/",
    searchStudent: "/api/admin/user_operation/",
    sendEmail: "/api/v1/admin/send-single-invite",
    getCSVData: "/api/admin/student_list/",
    translateText: "/api/v1/translate/translate",
    sendInvites: "/api/admin/send_invites/",
    goalBySchool: "/api/v1/studentgoal/goals_by_school",
    goalPublish: "/api/v1/goalpublish",
    updateSchoolGoal: "/api/v1/studentgoal/update_school_goal",
    withoutCounselor: "/api/admin/without_counselor/",
    districtPage: "/api/v1/admin/district_school_pagination",
    districtSftpPage: "/api/admin/sftp_status/",
    createSchool: "/api/admin/school_detail_view/",
    getSelectedCourse: "/api/v1/course",
    // getSchoolsList: "/api/v1/admin/school",
    // getCounselorsList: "/api/v1/admin/user",
    // getCollegesList: "/api/v1/admin/college",
    // getDistrictsList: "/api/v1/admin/district",
    // getStudentStatistics: "/api/v1/statistics/all",
    // searchStudent: "/api/v1/admin/page",
    // sendEmail: "/api/v1/admin/send-single-invite",
    // getCSVData: "/api/v1/admin/users-to-invite",
    getDeleteSchool: "/api/admin/school_detail_view/",
    getUpdateSchool: "/api/admin/school_detail_view/",
    getRecruiter: "/api/admin/user_operation/",
    getExportRecruiter: "/api/admin/export_result_report/",
    recruiterAdmin: "/api/v1/admin/user",
    subscribeContract: "/api/v1/admin/change_signed_status",
    updateRecruiter: "/api/admin/user_operation/",
    districtPage: "/api/admin/contract_setup/",
    subscribeContract: "/api/admin/contract_setup/",
    getGoalDetail: "/api/admin/goal_view/",
    createRecruiter: "/api/admin/user_operation/",
    getAdminSchoolIT: "/api/admin/user_operation/",
    goalAdminPage: "/api/v1/goal/page",
    coursePage: "/api/v1/course/page",
    goalAdminPublish: "/api/v1/goalpublish/publish",
    courseAdminPublish: "/api/v1/coursepublish/publish",
    duplicateAdminGoal: "/api/v1/goal/duplicate",
    goalField: "/api/v1/goalfield",
    listOfCourse: "/api/v1/course",
    getCourse: "/api/v1/course",
    goalRequiredField: "/api/v1/goalfield",
    goalFieldData: "/api/admin/goal_field_types/",
    saveType: "/api/admin/goal_field_types/",
    goalExpressionData: "/api/admin/expression_types/",
    saveExpression: "/api/admin/expression_types/",
    operatorShowData: "/api/admin/field_operators/",
    saveOperator: "/api/admin/field_operators/",
    arithemeticShowData: "/api/admin/arithmatic_operators/",
    saveArthOptr: "/api/admin/arithmatic_operators/",
    typeShowData: "/api/admin/field_types/",
    saveField: "/api/admin/field_types/",
    queryCriteriasShowData: "/api/admin/configuration_list/",
    saveCriteria: "/api/admin/configuration_list/",
    getCourseList: "/api/v1/goal",
    saveCourse: "/api/v1/configure/type",
    getLoginAnalytics: "/api/admin/login_analytics/",
    exportLoginAnalytics: "/api/admin/export_login_analytics/"
  }
};
